var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.25V1.71875C8.46094 2.07031 9.75 3.57031 9.75 5.375V5.82031C9.75 6.92188 10.1484 8 10.875 8.82031L11.0391 9.00781C11.25 9.24219 11.2969 9.54688 11.1797 9.82812C11.0625 10.0859 10.7812 10.25 10.5 10.25H1.5C1.19531 10.25 0.914062 10.0859 0.796875 9.82812C0.679688 9.54688 0.726562 9.24219 0.9375 9.00781L1.10156 8.82031C1.82812 8 2.25 6.92188 2.25 5.82031V5.375C2.25 3.57031 3.51562 2.07031 5.25 1.71875V1.25C5.25 0.851562 5.57812 0.5 6 0.5C6.39844 0.5 6.75 0.851562 6.75 1.25ZM6 12.5C5.60156 12.5 5.20312 12.3594 4.92188 12.0781C4.64062 11.7969 4.5 11.3984 4.5 11H7.5C7.5 11.3984 7.33594 11.7969 7.05469 12.0781C6.77344 12.3594 6.375 12.5 6 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/IconNotifications.b9b95c3f9ce0e82056d7b6e3cec1488f.svg";
export { ForwardRef as ReactComponent };